import isRelativeUrl from 'onyx-common/isRelativeUrl'

const wrapRelativeUrl = (urlToTest, wrapUrl) => {
  return isRelativeUrl(urlToTest) ? [wrapUrl, urlToTest].join('') : urlToTest
}

export default wrapRelativeUrl
